<template>
    <div id="transportation">
        <ul class="tab">
            <li v-for="(destinationPref, destinationPrefKey) in destinationPref" @click="onSelectPref(destinationPrefKey)" :class="{ current: selectedPref == destinationPrefKey }">{{destinationPref.name}}</li>
        </ul>

        <ul class="month_tab">
            <li class="m_list01" v-for="(month, monthKey) in monthList" @click="onSelectMonth(monthKey)" :class="{ current: selectedMonth[selectedPref] == monthKey }">{{month.format('YYYY年M月')}}</li>
        </ul>

        <div class="contents_wrap">
            <template v-for="(destinationPref, destinationPrefKey) in destinationPref">
                <template v-for="(month, monthKey) in monthList">
                    <div class="box" v-if="!destination[destinationPrefKey][monthKey]" v-show="destinationPrefKey == selectedPref && monthKey == selectedMonth[selectedPref]">
                        <div class="no_data">
                            <div class="text">ツアー情報が見つかりませんでした</div>
                        </div>
                    </div>
                    <div class="box" v-else v-show="destinationPrefKey == selectedPref && monthKey == selectedMonth[selectedPref]">
                        <div class="transport_table">
                            <table class="m_table01">
                                <tbody>
                                    <tr>
                                        <th></th>
                                        <th class="row_head sun">朝発バス</th>
                                        <th class="row_head moon">夜発バス</th>
                                        <th class="row_head bullet">新幹線</th>
                                    </tr>
                                    <tr v-for="(destination, destinationKey) in destination[destinationPrefKey][monthKey]">
                                        <th class="line_head">{{destination.name}}</th>
                                        <td v-for="(trans, transKey) in transList">
                                            <a :href="'/search/' + apiUrlList[trans.id][destinationPrefKey][monthKey][destinationKey]">{{priceList[trans.id][destinationPrefKey][monthKey][destinationKey]}}</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </template>
            </template>
        </div>


        
        <vue-element-loading :active="isLoading"  :is-full-screen="false"/>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue'
export default ({
    props: {
        // 引数の受け問
        departure_area : {type: String, require: true},
        departure_pref : {type: String, require: true},
        destination_area : {type: String, require: true},
        destination_pref : {type: String, require: true},
        destination : {type: String, require: true},
        trans_list : {type: String, require: true},
        month_list : {type: String, require: true},
    },
    setup(props, context) {
        const isLoading = ref(true)

        let transList = JSON.parse(props.trans_list)
        transList.pop()

        let departureArea = JSON.parse(props.departure_area)
        let departurePref = JSON.parse(props.departure_pref)
        let destinationArea = JSON.parse(props.destination_area)
        let destinationPref = JSON.parse(props.destination_pref)
        let destination = JSON.parse(props.destination)

        let monthList = JSON.parse(props.month_list)
        let tmpMonthList = {}
        Object.keys(monthList).forEach(function (monthKey) {
            let targetMonth = dayjs(monthList[monthKey])
            tmpMonthList[targetMonth.format('YYYYMM')] = targetMonth
        })
        monthList = tmpMonthList

        // 管理オブジェクトの生成
        const selectedPref = ref(Object.entries(destinationPref)[0][1].id)
        const selectedMonth = ref({})
        Object.keys(destinationPref).forEach(function (prefKey) {
            selectedMonth.value[prefKey] = Object.entries(monthList)[0][0]
        })

        const priceList = ref([])
        let apiUrlList = []
        Object.keys(transList).forEach(function (transKey) {

            if (transKey == 3) return;

            priceList.value[transList[transKey].id] = []
            apiUrlList[transList[transKey].id] = []

            Object.keys(destination).forEach(function (destinationPrefKey) {
                priceList.value[transList[transKey].id][destinationPrefKey] = []
                apiUrlList[transList[transKey].id][destinationPrefKey] = []

                Object.keys(destination[destinationPrefKey]).forEach(function (destinationMonthKey) {
                    priceList.value[transList[transKey].id][destinationPrefKey][destinationMonthKey] = []
                    apiUrlList[transList[transKey].id][destinationPrefKey][destinationMonthKey] = []
                    Object.keys(destination[destinationPrefKey][destinationMonthKey]).forEach(function (destinationKey) {
                        priceList.value[transList[transKey].id][destinationPrefKey][destinationMonthKey][destinationKey] = "読込中"

                        let destinationPrefId = Object.entries(destination[destinationPrefKey][destinationMonthKey][destinationKey].parentIdList)[0][1]
                        let destinationAreaId = Object.entries(destinationPref[destinationPrefId].parentIdList)[0][1]

                        let departureAreaSlug = departureArea[Object.entries(departurePref.parentIdList)[0][1]].slug
                        let destinationAreaSlug = destinationArea[destinationAreaId].slug
                        let destinationPrefSlug = destinationPref[destinationPrefId].slug

                        let paramList = [
                            "deptArea_" + departureAreaSlug,
                            "deptPref_" + departurePref.slug,
                            "destArea_" + destinationAreaSlug,
                            "destPref_" + destinationPrefSlug,
                            "dest_" + destination[destinationPrefKey][destinationMonthKey][destinationKey].slug,
                            "tran_" + transList[transKey].slug,
                            "date_" + monthList[destinationMonthKey].format("YYYYMM"),
                        ]
                        paramList = paramList.filter(Boolean)
                        apiUrlList[transList[transKey].id][destinationPrefKey][destinationMonthKey][destinationKey] = paramList.join("/")
                    })
                })
            })
        })

        // 金額情報の読み込み
        // 完了時
        onMounted(() => {
            let urlList = []
            Object.keys(apiUrlList).forEach(function (transKey) {
                Object.keys(apiUrlList[transKey]).forEach(function (destinationPrefKey) {
                    Object.keys(apiUrlList[transKey][destinationPrefKey]).forEach(function (destinationMonthKey) {
                        Object.keys(apiUrlList[transKey][destinationPrefKey][destinationMonthKey]).forEach(function (destinationKey) {
                            urlList.push(apiUrlList[transKey][destinationPrefKey][destinationMonthKey][destinationKey])
                        })
                    })
                })
            })

            if(urlList.length == 0) {
                isLoading.value = false
                return;
            }

            axios.post("/api/bestPrice/", {
                urlList: urlList,
            })
            .then(function (response) {
                Object.keys(apiUrlList).forEach(function (transKey) {
                    Object.keys(apiUrlList[transKey]).forEach(function (destinationPrefKey) {
                        Object.keys(apiUrlList[transKey][destinationPrefKey]).forEach(function (destinationMonthKey) {
                            Object.keys(apiUrlList[transKey][destinationPrefKey][destinationMonthKey]).forEach(function (destinationKey) {
                                let bestPrice = null
                                if (response.data.bestPriceList[apiUrlList[transKey][destinationPrefKey][destinationMonthKey][destinationKey]] != null){
                                    bestPrice = response.data.bestPriceList[apiUrlList[transKey][destinationPrefKey][destinationMonthKey][destinationKey]] .price
                                }

                                if (bestPrice) {
                                    priceList.value[transKey][destinationPrefKey][destinationMonthKey][destinationKey] = bestPrice.toLocaleString() + "円～"
                                } else {
                                    priceList.value[transKey][destinationPrefKey][destinationMonthKey][destinationKey] = "-"
                                }
                            })
                        })
                    })
                })

                isLoading.value = false
            })
        })

        // 都道府県をクリックされたときの挙動
        // メソッド実装 押されたとき
        const onSelectPref = (prefValue) => {
            selectedPref.value = prefValue
        }

        const onSelectMonth = (monthValue) => {
            selectedMonth.value[selectedPref.value] = monthValue
        }

        return {
            transList,
            departurePref,
            monthList,
            destinationPref,
            destination,
            selectedPref,
            selectedMonth,
            priceList,
            apiUrlList,
            onSelectPref,
            onSelectMonth,
            isLoading,
        }
    },
})
</script>